import { Antenna, Device, removeExtension } from '@ubnt/link-core/modules/devices';
import { CUSTOM_IMAGE_PREFIX } from '@ubnt/wifi-calculator/device/customClients';
import { buildNamePathsMap, ImageFile } from '@ubnt/wifi-calculator/utils/imageUtils';

const previewImages: Record<string, ImageFile> = import.meta.glob(
  [
    '/node_modules/@ubnt/link-core-common/unbundledAssets/devices/previewImages/unifi/*.{avif,webp,png}',
    '/node_modules/@ubnt/link-core-common/unbundledAssets/devices/previewImages/clientDevices/*.{avif,webp,png}',
  ],
  { eager: true }
);

const previewImagePrefixLength = '/node_modules/@ubnt/link-core-common/unbundledAssets/devices/previewImages/'.length;
const previewImagePaths = buildNamePathsMap(previewImages, previewImagePrefixLength);
const getPreviewImage = (name: string) => {
  const baseName = removeExtension(name);
  return previewImagePaths[baseName] ?? '';
};

const customClientImages: Record<string, ImageFile> = import.meta.glob(
  '/src/calculator/device/images/**/*.{avif,webp,png}',
  {
    eager: true,
  }
);
const customClientImagesPrefixLength = '/src/calculator/device/images/'.length;
const customClientImagePaths = buildNamePathsMap(customClientImages, customClientImagesPrefixLength);

const getCustomClientImage = (name: string) => {
  const baseName = removeExtension(name);
  return customClientImagePaths[baseName] ?? '';
};

Object.defineProperties(Device.prototype, {
  oldImgSrc: {
    get() {
      return ''; // we don't use this anymore
    },
  },
  imgSrc: {
    get(this: Device) {
      const previewImg = this._data.previewImg;
      if (previewImg) {
        if (previewImg.startsWith(CUSTOM_IMAGE_PREFIX)) {
          const imageName = previewImg.slice(CUSTOM_IMAGE_PREFIX.length);
          return getCustomClientImage(imageName);
        }
        return getPreviewImage(previewImg);
      }
      return '';
    },
  },
});

Object.defineProperties(Antenna.prototype, {
  imgSrc: {
    get(this: Antenna) {
      const imageName = this._data.previewImg;
      if (imageName) {
        return getPreviewImage(imageName);
      }
      return '';
    },
  },
});
